<template>
    <div class="overall-bg">
        <b-container>
            <b-row>
                <b-col>
                    <BacktoPage path="/Masters"></BacktoPage>
                    <Headerlayout :headertext="t('assetManagement.locationMaster.tableheading')"
                        :contenttext="t('assetManagement.locationMaster.tableHeaderContent')">
                    </Headerlayout>
                </b-col>
            </b-row>

            <b-row class="py-3">
                <b-col>
                    <div v-if="windowWidth > 545">
                        <SkeletonTableLoader :columns="headers" :loading="loading" />
                        <div v-if="!loading">
                            <MasterEmpty v-if="items.length === 0 && !loading"
                                :eheader="t('assetManagement.locationMaster.tableheading')"
                                :econtent="t('assetManagement.locationMaster.tableheading')"
                                eimg="/src/assets/Img/icons/taxmaster.svg" @createNew="IsCreate" />
                            <Tableview v-if="items.length !== 0" :value="items" :paginator="true"
                                class="p-datatable-gridlines" :rows="10" :rowHover="true" filterDisplay="menu"
                                :loading="loading1" responsiveLayout="scroll" :columns="headers"
                                :globalFilterFields="globalFilterFields" :filters="filters" selectionMode="single"
                                @row-click="RowClick" :exceldownload="true">
                                <template v-slot:Add>
                                    <span class="add">
                                        <AddButton @click="IsCreate()" :btnname="t('btn.plusaddnew')"
                                            class="float-rights my-3">
                                        </AddButton>
                                    </span>
                                </template>
                                <template v-slot:exceldownload>
                                    <ExportOption @ExportExcel="ExportExcel" @ExportPDF="ExportPDF"
                                        :ExportList="ExportList"
                                        :PageName="t('assetManagement.locationMaster.tableheading')"
                                        :ExportOption="ExportOption" class="ms-2" :HideAndShow="true" />
                                </template>
                                <template v-slot:Status="{ data }">

                                    <OrangeStatus name="InActive" v-if="data.IsActive == '0'" />
                                    <GreenStatus name="Active" v-if="data.IsActive == '1'" />
                                </template>
                                <template v-slot:action="{ data }">
                                    <span>

                                        <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                                            @click="toggle($event, data)" />
                                    </span>
                                </template>
                            </Tableview>
                        </div>
                    </div>
                    <div v-if="windowWidth <= 545">
                        <MobileLoader v-if="loading" v-for="item in 5" />
                        <div v-if="!loading">
                            <MasterEmpty v-if="items.length === 0 && !loading"
                                :eheader="t('assetManagement.locationMaster.tableheading')"
                                :econtent="t('assetManagement.locationMaster.tableheading')"
                                eimg="/src/assets/Img/icons/taxmaster.svg" @createNew="IsCreate" />
                            <MobileViewCardHeader>
                                <template v-slot:mobilecard>
                                    <div class="mobile-card" v-for="item in items">
                                        <div class="d-flex align-items-center justify-content-between gap-2">
                                            <div>
                                                <p class="light-name">{{ item.TaxCode }}</p>
                                                <p class="name">{{ item.TaxName }}</p>
                                            </div>
                                            <div class="d-flex align-items-center">
                                                <div>

                                                    <OrangeStatus name="InActive" v-if="item.IsActive == '0'" />
                                                    <GreenStatus name="Active" v-if="item.IsActive == '1'" />
                                                </div>
                                                <i class="pi pi-ellipsis-v" @click="toggle($event, item)"></i>
                                            </div>
                                        </div>
                                        <p class="light-name">{{ item.TaxType }}</p>
                                        <p class="light-name">{{ item.TaxSubType }}</p>
                                    </div>
                                </template>
                            </MobileViewCardHeader>

                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>


    <Menu ref="menu" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
    <Mapping :content="ContentName" :visible="MappingPopup" @ok="closemapping()" />
    <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />
    <ActivatedSuccessfully :visible="popup.activatepop" @ok="closetrigger()" />
    <InActivatedSuccessfully :visible="popup.inactivepop" @ok="closetrigger()" />
    <DeleteConfirmationVue :DeleteModel="Deletemodel" :content="content" @yes="IsDelete(dataEdit)"
        @no="Deletemodel = false" />
    <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit()" @no="Editmodel = false"
        :content="t('confirmation.editcontent')" />


    <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, h, computed, onUnmounted } from "vue";
import Headerlayout from "../../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../../components/FormComponents/BacktoMaster.vue";
import { RouterLink, RouterView, useRouter } from "vue-router";
import TaxService from "../../../../../../../modules/Inventory/Service/TaxService";
import Tableview from "../../../../../../../components/FormComponents/Table.vue";
import { useI18n } from 'vue-i18n';
import { FilterMatchMode, FilterOperator } from "primevue/api";
import EditConfirmation from "../../../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import MasterEmpty from "../../../../../../../components/Masters/MasterEmpty.vue";
import Mapping from "../../../../../../../components/FormComponents/Mapping.vue";
import Loader from "../../../../../../../components/FormComponents/Loader.vue";
import ActivatedSuccessfully from "../../../../../../../components/FormComponents/ActivateSuccessfully.vue";
import InActivatedSuccessfully from "../../../../../../../components/FormComponents/InActivateSuccessfully.vue";
import { MenuItemModel } from "../../../../../../../modules/Inventory/pages/AssetManagement/Masters/model/menuInterface";
import MastersService from "../../../../../../../modules/Inventory/Service/MastersService";
import { useToast } from "primevue/usetoast";
import { checkPermission } from "../../../../../../../modules/Inventory/Service/AccessControl";
import SkeletonTableLoader from "../../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import ExportOption from "../../../../../../../components/FormComponents/Export.vue";

export default defineComponent({
    components: {
        DeletedSuccessfully,
        EditConfirmation,
        DeleteConfirmationVue,
        Tableview,
        BacktoPage,
        Headerlayout,
        MasterEmpty,
        Loader,
        Mapping,
        ActivatedSuccessfully,
        InActivatedSuccessfully,
        SkeletonTableLoader,
        MobileViewCardHeader,
        MobileLoader,
        ExportOption,
    },
    setup() {
        let ObjOperationId = ref({
            CreateId: 0,
            UpdateId: 0,
            ReadId: 0,
            DeleteId: 0,
        });
        const toast = useToast();
        const router = useRouter();
        const Editmodel = ref(false);
        const { t } = useI18n();
        let MappingPopup = ref(false);
        let ContentName = ref("");

        let loading = ref(false);
        let loading1 = ref(false);
        const ObjData = ref();
        const popup = ref({
            activatepop: false,
            inactivepop: false,
        });
        let content = ref("");

        let taxId = 0;
        const deletepop = ref(false);
        const Deletemodel = ref(false);
        const menu = ref();
        let InActivevisible = ref(false);
        let Activevisible = ref(false);
        let Editvisible = ref(false);
        const dataEdit = ref();
        const rowFocus = ref(false);

        const items: any = ref([]);

        const filters = {
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            TaxName: { value: null, matchMode: FilterMatchMode.IN, options: items },
            TaxType: { value: null, matchMode: FilterMatchMode.IN, options: items },
            TaxSubType: {
                value: null,
                matchMode: FilterMatchMode.IN,
                options: items,
            },
            ActiveStatus: {
                value: null,
                matchMode: FilterMatchMode.IN,
                options: items,
            },
        };

        const windowWidth = ref(window.innerWidth);
        const handleResize = () => {
            windowWidth.value = window.innerWidth;
        };

        //DataTable Fields
        const headers = [
            {
                header: t('assetManagement.locationMaster.sno'),
                field: "RowNumber",
                class: "filterdisplaynone",
            },
            {
                header: t('assetManagement.locationMaster.code'),
                field: "TaxCode",
                class: "smallwidth",
            },
            {
                header: t('assetManagement.locationMaster.name'),
                field: "TaxName",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                bodyclass: "boldclass text_overflow2",
                class: "mediumwidth",
            },

            {
                header: t('assetManagement.locationMaster.city'),
                field: "TaxType",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                bodyclass: "text_overflow2",
                class: "mediumwidth",
            },
            {
                header: t('assetManagement.locationMaster.state'),
                field: "TaxSubType",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "smallwidth",
            },
            {
                header: t('assetManagement.locationMaster.country'),
                field: "TaxSubType",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "smallwidth",
            },
            {
                header: t('assetManagement.locationMaster.status'),
                field: "ActiveStatus",
                fieldDisplay: "false",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                bodyclass: "bluecolor",
                slot: "Status",
            },
            {
                field: "",
                header: "",
                slot: "action",
                frozencolumn: true,
                sortable: false,
                class: "filterdisplaynone last-column-position",
                fieldDisplay: "false",
            },
        ];

        const filteredColumns = computed(() => {
            return headers.filter((col) => col.field !== "id");
        });
        const globalFilterFields = ref(headers.map((col) => col.field));

        let ExportOption = ref("");
        let ExportList = ref([]);


        function ExportExcel() {
            debugger;
            ExportOption.value = "Excel";
            IsShowExport();
        }

        function ExportPDF() {
            debugger;
            ExportOption.value = "PDF";
            IsShowExport();
        }

        async function IsShowExport() {
            debugger;
            try {
                loading.value = false;

                const response = await TaxService.GetTaxTable();
                console.log(response["result"]);
                let count = 0;

                response["result"] = response["result"]
                    .filter((items) => items.HospitalId == usersData.OrganizationId)
                    .map((item) => {
                        count = count + 1;
                        item.RowNumber = count;
                        item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
                        return item;
                    });


                ExportList.value = response["result"].map((item) => {
                    const filteredItem = {};

                    headers.forEach(({ header, field }) => {
                        filteredItem[header] = item[field];
                    });

                    return filteredItem;
                });

                console.log("ContactTable Data", items.value);

                loading.value = false;
            } catch (error) {
                loading.value = false;
            }
        }


        //get local storage session data
        let SessionUserData = localStorage.getItem("UsersData");
        let usersData;
        if (SessionUserData !== null) {
            usersData = JSON.parse(SessionUserData);
        }

        let SessionRolesData = localStorage.getItem("RolesData");
        let rolesData;
        if (SessionRolesData !== null) {
            rolesData = JSON.parse(SessionRolesData);
        }

        let SessionEntityData = localStorage.getItem("EntityData");
        let EntityData;
        if (SessionEntityData !== null) {
            EntityData = JSON.parse(SessionEntityData);
        }
        //

        onMounted(() => {
            window.addEventListener("resize", handleResize);

            document.addEventListener("keydown", onKeyUp);

            taxtable();
            FunctionRights();
        });

        onUnmounted(() => {
            window.removeEventListener("resize", handleResize);
        });

        let Rights = ref({
            Create: false,
            Update: false,
            Read: false,
            Delete: false,
        });

        async function FunctionRights() {
            debugger;
            const response = await MastersService.CheckMenuRights(
                EntityData.EntityId,
                rolesData.RoleId
            );
            console.log(response["result"]);

            for (let i = 0; i < response["result"].length; i++) {
                const operation = response["result"][i];
                if (operation.OperationName === "Create") {
                    ObjOperationId.value.CreateId = operation.OperationID;
                    Rights.value.Create = operation.IsActive;
                } else if (operation.OperationName === "Update") {
                    ObjOperationId.value.UpdateId = operation.OperationID;
                    Rights.value.Update = operation.IsActive;
                } else if (operation.OperationName === "Read") {
                    ObjOperationId.value.ReadId = operation.OperationID;
                    Rights.value.Read = operation.IsActive;
                } else if (operation.OperationName === "Delete") {
                    ObjOperationId.value.DeleteId = operation.OperationID;
                    Rights.value.Delete = operation.IsActive;
                }
            }
        }

        const toggle = (event, data) => {
            debugger;
            ObjData.value = data;

            if (data.IsActive == 1) {
                InActivevisible.value = true;
                Activevisible.value = false;
            } else {
                InActivevisible.value = false;
                Activevisible.value = true;
            }

            menu.value.toggle(event);
        };

        const itemListed = ref<MenuItemModel[]>([
            {
                items: [
                    {
                        label: "Edit",
                        icon: "editicon pi pi-pencil",
                        visible: InActivevisible,
                        command: async () => {
                            Editdata(ObjData.value);
                        },
                    },
                    {
                        label: "Delete",
                        icon: "deleteicon pi pi-trash",
                        visible: true,
                        command: async () => {
                            Deletedata(ObjData.value, 0);
                        },
                    },

                    {
                        label: "Active",
                        icon: "editicon pi pi-check-circle",
                        visible: Activevisible,
                        command: async () => {
                            Deletedata(ObjData.value, 1);
                        },
                    },
                    {
                        label: "InActive",
                        icon: "deleteicon pi pi-minus-circle",
                        visible: InActivevisible,
                        command: async () => {
                            Deletedata(ObjData.value, 2);
                        },
                    },
                ],
            },
        ]);

        //IsEdit Route
        function IsEdit() {
            router.push({
                path: "/locationMasterCreation",
                query: {
                    Id: taxId,
                    OperationId: ObjOperationId.value.UpdateId,
                },
            });
        }

        // row click for table
        function RowClick(event: any) {
            debugger;
            rowFocus.value = true;
        }

        const taxtable = async () => {
            try {
                debugger;
                loading.value = true;
                const response = await TaxService.GetTaxTable();
                console.log(response["result"]);
                let count = 0;

                response["result"] = response["result"]
                    .filter((items) => items.HospitalId == usersData.OrganizationId)
                    .map((item) => {
                        count = count + 1;
                        item.RowNumber = count;
                        item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
                        return item;
                    });

                items.value = response["result"];
                loading.value = false;
                debugger;
            } catch (error) {
                alert(error);
            }
        };

        async function IsDelete(data) {
            Deletemodel.value = false;

            loading.value = true;
            debugger;
            try {
                let response: any = "";
                if (data.ActiveStatus == 0) {
                    response = await TaxService.deletedata(data.Id);
                } else {
                    let status = data.ActiveStatus == 1 ? true : false;
                    response = await TaxService.active(data.Id, status);
                }

                let message = response["ErrorInfo"].ErrorCode;
                loading.value = false;

                if (response["result"] != "False" && message == null) {
                    Deletemodel.value = false;
                    ContentName.value = response["result"];
                    MappingPopup.value = true;
                } else if (message == null) {
                    if (data.ActiveStatus == 1) {
                        popup.value.activatepop = true;
                    } else if (data.ActiveStatus == 2) {
                        popup.value.inactivepop = true;
                    } else {
                        deletepop.value = true;
                    }
                    Deletemodel.value = false;
                    rowFocus.value = false;
                    taxtable();
                }
            } catch (error) {
                alert(error);
            }
        }

        const edit = (data) => {
            router.push({
                path: "/locationMasterCreation",
                query: {
                    Id: data.Id,
                },
            });
        };

        const IsCreate = () => {
            let permissionResult: any = checkPermission(Rights, "Add");
            if (permissionResult.hasPermission) {
                router.push({
                    path: "/locationMasterCreation",
                    query: { OperationId: ObjOperationId.value.CreateId },
                });
            } else {
                router.push({
                    path: "/locationMasterCreation",
                    query: { OperationId: ObjOperationId.value.CreateId },
                });
                // toast.add(permissionResult.toast);
                return;
            }
        };

        function Editdata(data) {
            debugger;
            let permissionResult: any = checkPermission(Rights, "Edit");
            if (permissionResult.hasPermission) {
                taxId = data.Id;
                Editmodel.value = true;
            } else {
                toast.add(permissionResult.toast);
                return;
            }
        }
        function Deletedata(data, status) {
            let permissionResult: any = checkPermission(Rights, "Delete");
            if (permissionResult.hasPermission) {
                taxId = data.Id;
                dataEdit.value = data;
                Deletemodel.value = true;
                data.ActiveStatus = status;
                if (status == 1) {
                    content.value = "Activate";
                } else if (status == 2) {
                    content.value = "InActivate";
                } else {
                    content.value = t('confirmation.deletecontent');
                }
            } else {
                toast.add(permissionResult.toast);
                return;
            }
        }

        // Popup-Close
        function closemapping() {
            MappingPopup.value = false;
        }

        function onKeyUp(event: any) {
            debugger;

            console.log(dataEdit.value);
            if (
                (event.key == "e" ||
                    (Editmodel.value == false && event.key == "Enter")) &&
                rowFocus.value == true &&
                Deletemodel.value == false
            ) {
                // IsEdit(dataEdit.value)
                Editmodel.value = true;
            } else if (
                event.altKey &&
                event.key == "n" &&
                Editmodel.value == false &&
                Deletemodel.value == false
            ) {
                IsCreate();
            } else if (
                (event.key == "y" || event.key == "Enter") &&
                Deletemodel.value == true &&
                Editmodel.value == false &&
                rowFocus.value == true
            ) {
                IsDelete(dataEdit.value);
            } else if (
                (event.key == "y" || event.key == "Enter") &&
                Editmodel.value == true &&
                rowFocus.value == true
            ) {
                IsEdit();
            } else if (
                event.key == "n" &&
                rowFocus.value == true &&
                Editmodel.value == true
            ) {

                Editmodel.value = false;
            } else if (
                event.key == "d" &&
                rowFocus.value == true &&
                Editmodel.value == false
            ) {
                Deletemodel.value = true;
                Editmodel.value = false;
            } else if (
                event.key == "n" &&
                rowFocus.value == true &&
                Deletemodel.value == true
            ) {
                Deletemodel.value = false;
            } else if (event.key == "Escape" && deletepop.value == true) {
                deletepop.value = false;
            } else if (event.key == "Enter" && rowFocus.value == false) {
                Editmodel.value = false;
            }
        }

        function closetrigger() {
            debugger;
            deletepop.value = false;
            popup.value.activatepop = false;
            popup.value.inactivepop = false;
        }

        return {
            t,
            closemapping,
            ContentName,
            MappingPopup,
            Deletedata,
            Deletemodel,
            deletepop,
            Editmodel,
            Editdata,
            IsCreate,
            taxtable,
            loading,
            IsDelete,
            headers,
            items,
            IsEdit,
            filters,
            globalFilterFields,
            filteredColumns,
            edit,
            RowClick,
            loading1,
            closetrigger,
            dataEdit,
            menu,
            toggle,
            itemListed,
            popup,
            content,
            windowWidth,
            ExportExcel,
            ExportOption,
            ExportPDF,
            ExportList,
        };
    },
});
</script>

<style lang="scss" scoped>
.mobilecategoryname {
    font-size: 16px;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    margin-top: -7px;
}

.mobilestorename {
    font-size: 14px;
    color: #999999;
}

.mobilestorelabel {
    font-size: 14px;
    font-weight: 600;
}
</style>
